import type { PaginatedApiParams } from '~/common/types/api.type';

/**
 * 공지사항 타입
 */
export enum NoticeType {
  NEWS = 'news',
  EVENT = 'event',
  MAINTENANCE = 'maintenance',
  FAQ = 'faq',
  POPUP = 'popup',
}

/**
 * /notices orderKey 필드
 */
export enum NoticeOrderKey {
  PUBLISHED_AT = 'publishedAt',
}

/**
 * WebNoticeListResponseDto
 * 공지사항/FAQ 목록 아이템
 */
export interface NoticeListItem {
  id: number;
  type: NoticeType;
  title: string;
  /** isContent=true 조회 시 포함 */
  content?: string;
  pinOrder: number;
  publishedAt: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * WebNoticeDetailResponseDto
 * 공지사항/FAQ 상세 조회 DTO
 */
export interface NoticeDetailItem {
  id: number;
  type: NoticeType;
  title: string;
  content: string;
  pinOrder: number;
  publishedAt: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * GET /notices 조회 파라미터
 * ✔ PaginatedApiParams<OrderKey> 재사용
 */
export interface NoticeListParams extends PaginatedApiParams<NoticeOrderKey> {
  type?: NoticeType[];
  /** true인 경우 본문(content) 포함 */
  isContent?: boolean;
}
